import quickfield from '../quickfield'
import extend from 'smart-extend'
# import SimplyBind from '@danielkalen/simplybind'

export setup = ()->
	for config in @props.fields
		@createField(config)

export createField = (config)->
	value = @props.formState.values[config.name]
	config = extend.clone({required:true, mobileWidth:'100%'}, config, {value})
	@transformFieldConfig?(config)	

	field = quickfield(config)
	@transformFieldOutput?(field)

	field.on 'input', ()=>
		@setValues(@collectValues())
	
	if config.value?
		@setValues(@collectValues())

	if field.els.input
		field.els.input.attr 'name', config.autofillName or config.name

	@fields.push field.appendTo(@fieldsContainer)

export collectValues = ()->
	o = {}
	
	for field in @fields
		o[field.name] = field.value

	return o

export validate = ()->
	invalid = []
	
	for field in @fields
		invalid.push(field) if not field.validateAndReport()

	return {invalid, valid:invalid.length is 0}

export validateSilent = ()->
	invalid = []
	
	for field in @fields
		invalid.push(field) if not field.validate()

	return {invalid, valid:invalid.length is 0}